import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, Subject     } from 'rxjs';
import { map, repeat, switchMap, tap } from 'rxjs/operators';

import { QueryCollectorService, CountersService, SidebarStorageService } from '@shared/services';

import { environment } from 'environments/environment';

@Injectable()
export class ExternalEmployeesCountersService {
  private get EE_COUNTERS_API(): string { return `${environment.apiUrl}api/portal/v3/external_employees_counters`; };

  private reloadCounter$ = new Subject<void>();
  private skipUpdate: boolean;
  constructor (
    private http:                  HttpClient,
    private sidebarStorageService: SidebarStorageService,
    private countersService:       CountersService,
    private queryCollectorService: QueryCollectorService,
  ) { }

  reloadCounters(skipUpdate: boolean = null): void {
    this.skipUpdate = skipUpdate;
    this.reloadCounter$.next();
  }

  get externalsCounters(): Observable<any> {
    return this.requestExternalsCounters().pipe(
      repeat({ delay: () => this.reloadCounter$ })
    );
  }

  private requestExternalsCounters(): Observable<any> {
    return of(this.EE_COUNTERS_API).pipe(
      map(url => url + this.queryCollectorService.getCountersQuery()),
      switchMap(url => this.http.get<any>(url)),
      tap(({ active }) => {
        this.sidebarStorageService.changeExternaEmployeesCount(active.length);
        this.countersService.checkForUpdates({ active }, 'externals', this.skipUpdate);
        this.skipUpdate = null;
      })
    );
  }

}
